/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "./LabelClass.js";
var n = /\[([^\[\]]+)\]/gi;

function r(r, i, o) {
  var _this = this;

  return r ? r.map(function (r) {
    var s = new e();

    if (s.read(r, o), s.labelExpression) {
      var _e = i.fields || i.layerDefinition && i.layerDefinition.fields || _this.fields;

      s.labelExpression = s.labelExpression.replace(n, function (n, r) {
        return "[".concat(t(r, _e), "]");
      });
    }

    return s;
  }) : null;
}

function t(e, n) {
  if (!n) return e;
  var r = e.toLowerCase();

  for (var _t = 0; _t < n.length; _t++) {
    var _e2 = n[_t].name;
    if (_e2.toLowerCase() === r) return _e2;
  }

  return e;
}

export { r as reader };